<template>
    <transition name="dropdown">
        <div class="dropdown-filter">
            <div class="row no-gutters" v-if="hasSelection">
                <div class="alink mr-1" v-if="filter.prezzo" @click="onRemove('prezzo')">
                    <span class="mr-2">PREZZO</span>
                    <b class="mr-1">&euro; {{minPriceF}}</b>-
                    <b>&euro; {{maxPriceF}}</b>
                </div>
                <div class="alink" v-if="filter.nome" @click="onRemove('nome')">
                    <span class="mr-2">NOME</span><b>{{filter.nome}}</b>
                </div>
            </div>
            <div class="bg-white">
                <form @submit.prevent>
                    <div class="form-group">
                        <label>Prezzo</label>
                        <div class="row no-gutters pl-2 pl-md-5 py-3 bg-light">
                            <div class="col-12">
                                <PriceRangeSlider ref="priceRangeSlider" :min-price="minPrice" :max-price="maxPrice" :value="filter.prezzo" @input="onInputPrezzo"/>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Nome</label>
                        <div class="row no-gutters p-3 bg-light">
                            <div class="col-12">
                                <input class="form-control" type="text" name="nome" :value="filter.nome" @input="onInputNome"/>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import {mapGetters} from 'vuex'
import PriceRangeSlider from '../../../common/PriceRangeSlider'
import {formatMoney} from '../../../../../utils/formatter'

export default {
  name: 'DropdownFilterTour',
  components: {PriceRangeSlider},
  props: {
    value: Object,
    minPrice: Number,
    maxPrice: Number
  },
  computed: {
    filter () {
      return this.value
    },
    hasSelection () {
      return this.filter.prezzo || this.filter.nome
    },
    minPriceF () {
      return formatMoney(this.filter.prezzo[0])
    },
    maxPriceF () {
      return formatMoney(this.filter.prezzo[1])
    }
  },
  methods: {
    ...mapGetters(['getListaServizi']),
    onInputNome (event) {
      const { value } = event.target
      // if (value.length < 3) return
      this.filter['nome'] = value
      this.$emit('change', this.filter)
    },
    onInputPrezzo (value) {
      this.filter['prezzo'] = value
      this.$emit('change', this.filter)
    },
    onSelect (property, item) {
      this.filter[property] = item
      this.$emit('change', this.filter)
    },
    onRemove (property) {
      this.$refs.priceRangeSlider.reset()
      this.filter[property] = null
      this.$emit('change', this.filter)
    }
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/tour-accompagnati/dropdown/DropdownFilterTour.vue